import React from 'react'
import {
    Form,
  Input,
  TextArea,
  Toast,
  Button,ImageUploader,Ellipsis,List,Picker,Modal,Dialog,NavBar,Image,Selector,WhiteSpace, Card
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import {
    GetDataDictionarysByCode,SaveNNFile,SaveGuestBook,GetGuestBook,GetSystemMemorys
  } from '../../service/service';

import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'
import { RightOutline } from 'antd-mobile-icons'
import { environment } from '../../service/baseUrl';

import '../MsgAdd/index.css'
import { useNavigate,useParams,useLocation } from 'react-router-dom';


const withNavigate = (WrappedComponent) => {
    return (props) => {
        const params = useParams();
        const navigate = useNavigate();
        const location = useLocation();
        return <WrappedComponent {...props} params={params} navigate={navigate} location={location} />;
    };
};

class Index extends React.Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            id: 0,
            planetId: 0,
            fileList: [],
            imgName: "",

            visible: false,
            valuePicker: "0",
            textPicker: "请选择",
            pickers: [
                [
                ]
            ],

            visibleOne: false,
            valuePickerOne: "0",
            textPickerOne: "请选择",
            pickerOne: [
                [
                ]
            ],

            msgInfo: {},
            userInfo: {},
            loading: false // 新增加载状态
        };
    }

    componentDidMount() {
        var that = this;

        GetDataDictionarysByCode("LiuYanlx").then(res => {
            if (res.success) {
                var arry = [];
                res.result.map(item => {
                    arry.push({ label: item.displayName, value: item.id })
                })
                that.setState({
                    pickers: [arry],
                    valuePicker: arry.length > 0 ? arry[0].value : "0",
                    textPicker: arry.length > 0 ? arry[0].label : "请选择",
                })
                this.formRef.current.setFieldsValue({
                    TypeId: arry.length > 0 ? arry[0].value : "0",
                })
            }
        })

        GetDataDictionarysByCode("NNSZGX").then(res => {
            if (res.success) {
                var arry = [];
                res.result.map(item => {
                    arry.push({ label: item.displayName, value: item.id })
                })
                that.setState({
                    pickerOne: [arry],
                    valuePickerOne:  arry.length > 0 ? arry[0].value : "0",
                    textPickerOne:  arry.length > 0 ? arry[0].label : "请选择",
                })
                this.formRef.current.setFieldsValue({
                    FamilyRelationOne:  arry.length > 0 ? arry[0].value : "0",
                })
            }
        })

        const { location } = this.props;
        const { planetId, id } = location.state || {}; // 获取 URL 参数
        this.setState({
            planetId: planetId,
            id: id,
        })
        if (id) {
            GetGuestBook(id).then(res => {
                if (res.success) {
                    var result = res.result;

                    this.formRef.current.setFieldsValue({
                        FamilyRelationName: res.result.familyRelationName,
                        SyncForum: res.result.syncForum == undefined ? [false] : [res.result.syncForum],
                        Remark: res.result.remark,
                        TypeId: res.result.typeId,
                    })

                    setTimeout(() => {
                        var item1 = that.state.pickers[0].filter(x => x.value == result.typeId);
                        var item2 = that.state.pickerOne[0].filter(x => x.value == result.familyRelationId);
                        that.setState({
                            valuePicker: result.typeId,
                            textPicker: item1[0] == null ? "请选择" : item1[0].label,
                            valuePickerOne: result.familyRelationId,
                            textPickerOne: item2[0] == null ? "请选择" : item2[0].label
                        })
                    }, 1000);

                    var list = []
                    result.imgs.map((item, index) => {
                        list.push({
                            key: 999 - index,
                            url: environment.apiEndpoint + item,
                            thumbnailUrl: environment.apiEndpoint + item,
                        })
                    })

                    that.setState({
                        id: id,
                        imgName: result.headImg,
                        msgInfo: result,
                        fileList: list,
                    })
                }
            })
        }

        var user = localStorage.getItem("user");
        if (user == null || user == undefined) {
            return;
        }

        this.setState({
            userInfo: JSON.parse(user)
        })

        this.formRef.current.setFieldsValue({
            SyncForum: [false],
            FamilyRelationName: JSON.parse(user).nickName
        })

    }

    submitForm = () => {
        // 如果正在加载中，直接返回，避免重复提交
        if (this.state.loading) {
            Toast.show({ icon: 'fail', content: '请勿重复提交！' });
            return;
        }

        var that = this;
        this.formRef.current.validateFields()
            .then(values => {
                var imgs = [];
                this.state.fileList.map(item => {
                    imgs.push(item.url.split('/').pop());
                });
                that.state.msgInfo.imgs = [];
                const submitData = {
                    ...that.state.msgInfo,
                    ...values,
                    FamilyRelationId: this.state.valuePickerOne,
                    TypeId: this.state.valuePicker,
                    Imgs: imgs,
                    PlanetId: this.state.planetId,
                    SyncForum: values.SyncForum == undefined ? false : values.SyncForum[0],
                };

                this.setState({ loading: true });
                SaveGuestBook(submitData).then(res => {
                    if (res.success) {
                        Toast.show({ icon: 'success', content: '提交成功！' });
                        setTimeout(() => {
                            that.props.navigate('/msg', { replace: true, state: { id: this.state.planetId } });
                        }, 2000);
                    } else {
                        this.setState({ loading: false });
                    }

                })
            })
            .catch(error => {
                if (error.errorFields) {
                    Toast.show({ icon: 'fail', content: '请检查表单' });
                } else {
                    Toast.show({ icon: 'fail', content: error.message || '提交失败' });
                }
            });
        
    }


    render() {

        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/msg', { replace: true, state: { id: this.state.planetId } }); // 传递状态
                }} style={{ 'border-bottom': 'solid 1px #e4e4e4', 'height': "6%" }}
                >
                    回忆留言
                </NavBar>

                <div className="msgAdd" style={{ height: "94%", backgroundColor: "rgb(195 195 195)", paddingTop: "5%" }}>

                    <div style={{ backgroundColor: "#fff", width: "92%", marginLeft: "4%", overflowY: "scroll", height: "98%" }}>
                        <Form
                            name='form'
                            ref={this.formRef}
                            footer={
                                <div>
                                    <div style={{
                                        backgroundImage: "url('https://api.weibinyi.com/images/niannian/4/13-09.png')"
                                        , backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", height: "38px"
                                        , marginLeft: "10%", width: "80%", textAlign: "center", fontSize: "17px", lineHeight: "38px"
                                        , fontWeight: "600", color: "#fff"
                                    }} onClick={() => {
                                        this.submitForm();
                                    }}>
                                        提 交
                                    </div>
                                </div>
                            }
                        >
                            <Form.Item name='FamilyRelationName' label="请问您如何称呼" rules={[{ required: true }]}>
                                <Input placeholder='请输入您的称呼' style={{ marginLeft: "10px" }} />
                            </Form.Item>
                            <Form.Item name='FamilyRelationOne' label="请问您与逝者的关系为">
                                <div onClick={() => {
                                    this.setState({
                                        visibleOne: true
                                    })
                                }}>
                                    <span style={{ fontSize: "14px", marginLeft: "3%" }}>{this.state.textPickerOne}</span>
                                    <span style={{ float: "right" }}>
                                        <RightOutline />
                                    </span>
                                </div>

                                <Picker
                                    columns={this.state.pickerOne}
                                    visible={this.state.visibleOne}
                                    onClose={() => {
                                        this.setState({
                                            visibleOne: false
                                        })
                                    }}
                                    value={[this.state.valuePickerOne]}
                                    onConfirm={(v) => {
                                        var value = v[0];
                                        var item = this.state.pickerOne[0].filter(x => x.value == value)
                                        this.setState({
                                            valuePickerOne: value,
                                            textPickerOne: item[0].label
                                        })
                                    }}
                                />
                            </Form.Item>

                            <div className="DeadDate">
                                <Form.Item name='TypeId' label="回忆类型" rules={[{ required: true }]}>
                                    <div onClick={() => {
                                        this.setState({
                                            visible: true
                                        })
                                    }}>
                                        <span style={{ fontSize: "14px", marginLeft: "3%" }}>{this.state.textPicker}</span>
                                        <span style={{ float: "right" }}><RightOutline /></span>
                                    </div>

                                    <Picker
                                        columns={this.state.pickers}
                                        visible={this.state.visible}
                                        onClose={() => {
                                            this.setState({
                                                visible: false
                                            })
                                        }}
                                        value={[this.state.valuePicker]}
                                        onConfirm={(v) => {
                                            var value = v[0];
                                            var item = this.state.pickers[0].filter(x => x.value == value)
                                            this.setState({
                                                valuePicker: value,
                                                textPicker: item[0].label
                                            })
                                            this.formRef.current.setFieldsValue({ TypeId: value });
                                        }}
                                    />
                                </Form.Item>
                            </div>

                            {/* <Form.Item name='HeadImg' label={<>
                                请上传一张纪念的照片<span style={{ color: "#9e9e9e", fontSize: "13px" }}>（选填）</span>
                            </>}>
                                <ImageUploader
                                    columns={3}
                                    maxCount={1}
                                    defaultValue={this.state.fileList}
                                    onChange={(file) => {
                                        this.setState({
                                            fileList: file
                                        })
                                    }}
                                    upload={(file) => {
                                        return {
                                            url: URL.createObjectURL(file),
                                        }
                                    }}
                                    children={
                                        <Image src={"https://api.weibinyi.com/images/niannian/4/2-12.png"} fit='fill'
                                            width={110} height={110} />
                                    }
                                />
                            </Form.Item> */}

                            <div style={{ marginBottom: "15px", marginLeft: "15px", marginRight: "15px" }}>
                                <div style={{
                                    marginLeft: "10px", lineHeight: "60px", fontSize: "0.373333rem",
                                    fontWeight: "600", color: "var(--adm-color-text-secondary)",
                                }}>
                                    请上传一张纪念的照片<span style={{ color: "#9e9e9e", fontSize: "13px" }}>（选填）</span>
                                </div>

                                <ImageUploader
                                    columns={3}
                                    maxCount={1}
                                    style={{ '--cell-size': '80px' }}
                                    value={this.state.fileList || []}
                                    defaultValue={this.state.fileList || []}
                                    beforeUpload={async (file) => {
                                        console.log('BeforeUpload - 文件信息:', file);
                                        if (!(file instanceof File)) {
                                            Toast.show({ icon: 'fail', content: '无效的文件！' });
                                            return false;
                                        }
                                        if (file.size > 5 * 1024 * 1024) {
                                            Toast.show({ icon: 'fail', content: '文件大小不能超过5MB！' });
                                            return false;
                                        }

                                        var res = await GetSystemMemorys(this.state.planetId);
                                        if (res.success) {
                                            var count = 0;
                                            res.result.map(item => {
                                                count += item.fileSize;
                                            })
                                            var maxSize = 300;
                                            var models = this.state.userInfo.planetSizes
                                                .filter(x => x.planetId == this.state.planetId);
                                            if (models != null && models.length > 0) {
                                                maxSize = models[0].fileSumSize;
                                            }
                                            if (count > maxSize) {
                                                Toast.show({ content: '该星球文件空间已满！' });
                                                return false;
                                            }
                                        }
                                        const fileCopy = new File([file], file.name, { type: file.type });
                                        return fileCopy;
                                    }}
                                    onChange={(fileList) => {
                                        console.log('OnChange - 文件列表:', fileList);
                                        this.setState({ fileList });
                                    }}
                                    upload={async (file) => {
                                        try {
                                            console.log('Upload - 开始上传:', file);

                                            // 1. 验证文件对象
                                            if (!(file instanceof File)) {
                                                throw new Error('无效的文件对象');
                                            }

                                            // 2. 创建临时预览URL
                                            const tempUrl = URL.createObjectURL(file);
                                            console.log('临时预览URL创建成功:', tempUrl);

                                            // 3. 上传文件
                                            const formData = new FormData();
                                            formData.append('file', file);
                                            formData.append('userid', this.state.userInfo.id);
                                            formData.append('scoureName', "LY");
                                            formData.append('planetId', this.state.planetId);

                                            const response = await SaveNNFile(formData);
                                            console.log('上传响应:', response);

                                            // 4. 确保返回正确的URL格式
                                            let imageUrl;
                                            if (typeof response === 'string') {
                                                imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                            } else if (response.result) {
                                                imageUrl = environment.apiEndpoint + `/NNFiles/Img/${response.result}`;
                                            } else {
                                                throw new Error('无效的服务器响应');
                                            }

                                            this.setState({
                                                imgName: response.result
                                            })
                                            // 5. 释放临时URL
                                            URL.revokeObjectURL(tempUrl);

                                            return {
                                                url: imageUrl
                                            };
                                        } catch (error) {
                                            console.error('上传过程出错:', error);
                                            Toast.show({ icon: 'fail', content: '上传失败' });
                                            throw error;
                                        }
                                    }}
                                    children={
                                        <Image src={"https://api.weibinyi.com/images/niannian/4/20250628181722.png"} fit='fill'
                                            width={100} height={100} />
                                    }
                                />

                            </div>

                            <Form.Item name='SyncForum' label='同步到银河论坛'>
                                <Selector
                                    columns={3}
                                    options={[
                                        { label: '是', value: true },
                                        { label: '否', value: false },
                                    ]}
                                />
                            </Form.Item>
                            <Form.Item name='Remark' label='请您写一则回忆故事或致意之词'>
                                <TextArea
                                    placeholder='请您写一则回忆故事或致意之词'
                                    maxLength={500} rows={6} showCount
                                    style={{
                                        border: 'solid 1px #c7c7c7', marginTop: '5px', borderRadius: '3%',
                                        marginBottom: '5px', padding: "10px"
                                    }}
                                />
                            </Form.Item>

                        </Form>
                    </div>

                </div>


            </div>
        )
    }
}

export default withNavigate(Index);